// Workspace library and GroupMe rooms. Both are tier-gated via minLevel.

export const LIBRARY = [
  {
    icon:"✝️",
    name:"Who We Are",
    desc:"CLLXTV identity: mission, beliefs, culture. History. Happens. Here.",
    minLevel:"member",
    id:"lib-who-we-are"
  },
  {
    icon:"🎨",
    name:"Brand & Design",
    desc:"The CLLXTV brand kit: logos, colors, type, every file a creative needs.",
    minLevel:"member",
    id:"lib-brand-and-design"
  },
  {
    icon:"🎵",
    name:"Worship & Music",
    desc:"Songs, keys, weekly audio, rehearsal sessions.",
    minLevel:"leader",
    id:"lib-worship-and-music"
  },
  {
    icon:"🎛️",
    name:"Production & Media",
    desc:"Run of show, slides, livestream signal flow, camera guide.",
    minLevel:"leader",
    id:"lib-production-and-media"
  },
  {
    icon:"🧒",
    name:"CLLXTV Kids",
    desc:"Curriculum, check-in, and child-safety protocols.",
    minLevel:"leader",
    id:"lib-cllxtv-kids"
  },
  {
    icon:"💰",
    name:"Finance",
    desc:"Invoices, receipts, reports, fund requests.",
    minLevel:"exec",
    id:"lib-finance"
  },
  {
    icon:"🪪",
    name:"Church Certificates",
    desc:"501c3, Tax ID (EIN), tax exemption — official documents.",
    minLevel:"exec",
    id:"lib-church-certificates"
  },
  {
    icon:"👔",
    name:"HR & Personnel",
    desc:"Offers, evaluations, onboarding docs.",
    minLevel:"senior",
    id:"lib-hr-and-personnel"
  },
  {
    icon:"👑",
    name:"Senior Pastor Folder",
    desc:"Sermon drafts, board docs, Ship Happens.",
    minLevel:"senior",
    id:"lib-senior-pastor-folder"
  }
];

export const GROUPME = [
  {
    icon:"📣",
    name:"CLLXTV HQ",
    desc:"Church-wide announcements. Everybody's in this one.",
    minLevel:"member",
    id:"gm-cllxtv-hq"
  },
  {
    icon:"🙌",
    name:"Dream Team",
    desc:"All serving team members, all teams.",
    minLevel:"member",
    id:"gm-dream-team"
  },
  {
    icon:"🎤",
    name:"Worship & Music",
    desc:"Set lists, rehearsals, Sunday flow.",
    minLevel:"leader",
    id:"gm-worship-and-music"
  },
  {
    icon:"🎛️",
    name:"Production & Media",
    desc:"Slides, cameras, sound, socials.",
    minLevel:"leader",
    id:"gm-production-and-media"
  },
  {
    icon:"🚪",
    name:"Guest Experience",
    desc:"Doors, lobby, first impressions.",
    minLevel:"leader",
    id:"gm-guest-experience"
  },
  {
    icon:"🧒",
    name:"CLLXTV Kids",
    desc:"Check-in, curriculum, classroom leads.",
    minLevel:"leader",
    id:"gm-cllxtv-kids"
  },
  {
    icon:"🔑",
    name:"Leaders Only",
    desc:"All team leaders. Sunday run-of-show lives here.",
    minLevel:"leader",
    id:"gm-leaders-only"
  },
  {
    icon:"🧭",
    name:"Directors",
    desc:"Campus directors. Strategy and staffing.",
    minLevel:"director",
    id:"gm-directors"
  },
  {
    icon:"🏛️",
    name:"Exec Staff",
    desc:"Executive team. Finance, launch, calendar.",
    minLevel:"exec",
    id:"gm-exec-staff"
  }
];
